import React, { useEffect, useState } from "react";
import Cart from "../Components/Layout/Cart/Cart";
import HeaderMinimal from "../Components/Layout/HeaderMinimal";
import { TbBuildingSkyscraper, TbCircleCheckFilled, TbId, TbMapPin, TbMessage, TbTicket } from "react-icons/tb";
import ButtonsCheckout from "../Components/Layout/Cart/ButtonsCheckout";
import Button from "../Components/Form/Button";
import { useStoreContext } from "../Contexts/StoreContext";
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import { useLoginContext } from "../Contexts/LoginContext";
import { ImSpinner8 } from "react-icons/im";
import { IMaskInput } from "react-imask";
import { formatAddressStore, goScrollTo, isCpfValid, orderTypeAsSlug } from '../Utils/Helpers'
import { formatCpf } from "../Utils/Formatters";
import CustomerService from "../Services/CustomerService";
import ButtonMethodPayment from "../Components/Form/ButtonMethodPayment";
import { useLayoutContext } from "../Contexts/LayoutContext";
import FormRegisterCustomerCard from "../Components/Form/FormRegisterCustomerCard";
import { METHOD_PAYMENT_TYPE_CARD_ONLINE, METHOD_PAYMENT_TYPE_GOOGLE_PAY, METHOD_PAYMENT_TYPE_PIX, ORDER_STATUS_AWAITING_PAYMENT } from "../Utils/Constants/Checkout";
import StoreService from "../Services/StoreService";
import OrderService from "../Services/OrderService";
import { useCheckoutContext } from "../Contexts/CheckoutContext";
import { useNavigate } from "react-router-dom";
import { useCartContext } from "../Contexts/CartContext";
import Modal from "../Components/Layout/Modal";
import Confirm, { CONFIRM_ICON_INVOICE } from "../Components/Layout/Confirm";
import { useCartHook } from "../Hooks/CartHook";
import { useStoreHook } from "../Hooks/StoreHook";
import CardEmpty from "../Components/Layout/Cart/CartEmpty";
import ButtonLink from "../Components/Form/ButtonLink";
import CardBoxCheckout from "../Components/Layout/CardBoxCheckout";
import ButtonPrimary from "../Components/Form/ButtonPrimary";
import GooglePayButton, { GooglePayParamsProps } from "../Components/Form/GooglePayButton";

const Checkout = () => {

    const [paymentMethod, setPaymentMethod] = useState<any>(null);
    const [showStoreAddress, setShowStoreAddress] = useState<boolean>(false);
    const { company, setMainLoading, setMainLoadingIcon, setMainLoadingIconInfo, setMainLoadingIconError, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton } = useLayoutContext();
    const { showPixCode, setShowPixCode } = useCheckoutContext();
    const [observation, setObservation] = useState('');
    const [showInputObservation, setShowInputObservation] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [couponCodeApplied, setCouponCodeApplied] = useState<boolean>(false);
    const [cpf, setCpf] = useState('');
    const [showInputCpf, setShowInputCpf] = useState(false);
    const [loading] = useState<boolean>(false);
    const [listAllPaymentMethods, setListAllPaymentMethods] = useState<any>(null);
    const [listPaymentMethods, setListPaymentMethods] = useState<any>(null);
    const [hasPaymentGooglePay, setHasPaymentGooglePay] = useState<boolean>(false);
    const [methodCardOnline, setMethodCardOnline] = useState<any>(null);

    const [loadingListPaymentMethods, setLoadingListPaymentMethods] = useState<boolean>(true);
    const [loadingGetCards, setLoadingGetCards] = useState<boolean>(true);
    const [labelBtnPay, setLabelBtnPay] = useState<string>('');

    const [customerCards, setCustomerCards] = useState<any>([]);
    const [currentCard, setCurrentCard] = useState<any>(null);
    const [showPrePayd, setShowPrePayd] = useState<boolean>(false);
    const [paymentMethodTypeGooglePay, setPaymentMethodTypeGooglePay] = useState<any>(null);

    const { currentStore, cashier } = useStoreContext();
    const { orderType, getOrderTypeIdByName, isStoreCounter, isDelivery } = useOrderTypeContext();
    const { token, user } = useLoginContext();
    const { order, setOrder } = useCheckoutContext();
    const { cartDisplay, setReturnToCheckout, currentCart, loadingCoupon } = useCartContext();
    const [showConfirmCancel, setShowConfirmCancel] = useState(false);
    const [showConfirmOrdersOpen, setShowConfirmOrdersOpen] = useState(false);
    const [isValidCouponCode, setIsValidCouponCode] = useState(false);
    const [showRegisterCard, setShowRegisterCard] = useState(false)
    const [cart, setCart] = useState<any>([]);
    const { cartFinished, applyCouponCode, removeCouponCode, checkOrdersOpen } = useCartHook();
    const { noOpenCashier, createGuestCart, storeIsOpen, getLinkToHome } = useStoreHook();
    const navigate = useNavigate();

    const goToOrderPlace = (order: any) => {
        navigate(`${getLinkToHome()}/order/${order.id}/placed`);
    }

    const goToHome = () => {
        navigate(getLinkToHome());
    }

    const handleCancel = () => {
        goToHome();
        setReturnToCheckout(false);
        setMainLoading(false);
    }

    const handleCoupon = () => {
        if (!couponCodeApplied) {
            if (isValidCouponCode) {
                applyCouponCode(couponCode, token);
            }
        } else {
            removeCouponCode(couponCode, token);
        }
    }

    useEffect(() => {
        const scriptId = 'google-pay-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.src = 'https://pay.google.com/gp/p/js/pay.js';
            script.async = true;
            script.id = scriptId;
            document.body.appendChild(script);
        }
    }, [])

    useEffect(() => {
        setIsValidCouponCode(Boolean(couponCode && couponCode !== '#'))
    }, [couponCode]);

    useEffect(() => {
        if ((isStoreCounter && !cartDisplay) || (!isStoreCounter && !token)) {
            goToHome();
        }

        if (showPixCode) {
            goToOrderPlace(order);
        }

        setMethodCardOnline({type: METHOD_PAYMENT_TYPE_CARD_ONLINE, register: true});

        document.title = currentStore?.name || company?.name;
        if (currentStore) {
            if (isStoreCounter && !cashier) {
                noOpenCashier();
                handleCancel();
            }

            const loadListPaymentMethods = async () => {
                setLoadingListPaymentMethods(true)
                try {
                    const storeSevice = new StoreService(orderType);
                    const payload = {
                        store_id: currentStore?.id,
                    }
                    const data = await storeSevice.listPaymentMethods(payload);
                    setListAllPaymentMethods(data);
                    if (Array.isArray(data)) {

                        if (isStoreCounter) {
                            setShowPrePayd(data.some((method: any) => method.type === METHOD_PAYMENT_TYPE_CARD_ONLINE && method.pdv === true));
                            const paymentMethodsForStoreCounter = data.filter((method: any) => {
                                if (method.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) {
                                    setHasPaymentGooglePay(true);
                                    setPaymentMethodTypeGooglePay(method);
                                }
                                return (
                                    (method.type === METHOD_PAYMENT_TYPE_PIX || method.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) && method.pdv
                                );
                            });
                            if (paymentMethodsForStoreCounter) {
                                setListPaymentMethods(paymentMethodsForStoreCounter)
                            }
                        } else {
                            //! UTILIZANDO SERVIÇO 'dinein' para o 'papa-fila', pois o serviço 'papa-fila' não existe
                            const checkDirectSaleService = orderTypeAsSlug(orderType) === 'papa-fila' || orderTypeAsSlug(orderType) === 'dine-in' ? 'dinein' : orderTypeAsSlug(orderType);

                            setShowPrePayd(data.some((method: any) => method.type === METHOD_PAYMENT_TYPE_CARD_ONLINE && method[checkDirectSaleService] === true));
                            const paymentMethodsForOthersTypes = data.filter((method: any) => {
                                if (method.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) {
                                    setHasPaymentGooglePay(true);
                                    setPaymentMethodTypeGooglePay(method);
                                }
                                return (
                                    (method.type === METHOD_PAYMENT_TYPE_PIX || method.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) && method[checkDirectSaleService] === true
                                );
                            });

                            if (paymentMethodsForOthersTypes) {
                                setListPaymentMethods(paymentMethodsForOthersTypes)
                            }
                        }
                    }
                }
                catch (error) {}
                finally {setLoadingListPaymentMethods(false)}
            }
            loadListPaymentMethods();
            getCustomerCards();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStoreCounter]);

    useEffect(() => {
        if (!isStoreCounter && currentCart) {
            setCart(currentCart);
            setCouponCode(currentCart.coupon_code);
            setCouponCodeApplied(currentCart.coupon_code);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCart]);

    useEffect(() => {
        if (!showPrePayd && listPaymentMethods && listPaymentMethods.length === 1) {
            handleChangeMethod(listPaymentMethods[0]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listPaymentMethods]);

    const handleSetCard = (data: any) => {
        setCurrentCard(data);
    }

    useEffect(() => {
        if (currentCard && paymentMethod) {
            getCustomerCards();
            handleCreateOrder();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCard, paymentMethod])

    const handleObservation = () => {
        setShowInputObservation(false)
    }

    const handleCpf = () => {
        setShowInputCpf(false);
    }

    const handleCheckOrdersOpen = () => {
        checkOrdersOpen(token)
            .then((response) => {
                if (response.hasOrderOpen) {
                    setShowConfirmOrdersOpen(true);
                } else {
                    handleCreateOrder();
                }
            })
            .catch((error) =>
                //! VERIFICAR ERRO DO checkOrdersOpen - NÃO ESTÁ VERIFICANDO
                handleCreateOrder()
            );
    }

    const handleCreateOrderWithGooglePay = (googlePayResponse: GooglePayParamsProps) => {
        handleCreateOrder(googlePayResponse);
    }


    const handleCreateOrder = async (googlePayResponse: GooglePayParamsProps | null = null) => {

        setShowConfirmOrdersOpen(false);
        const googlePayToken = googlePayResponse ? googlePayResponse.token : null;
        const billingAddress = googlePayResponse ? googlePayResponse.billingAddress : null;

        let payment_method = null;

        if (googlePayToken) {
            payment_method = listPaymentMethods.find((method: any) => method.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY);
        }

        const selectedPaymentMethod = payment_method || paymentMethod;

        if (!selectedPaymentMethod) {
            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconInfo(true);
            setMainLoadingTitle('Escolha como pagar');
            setMainLoadingMessage('Para continuar, selecione uma forma de pagamento disponível acima.');
            setMainLoadingCloseButton(true);
        } else {
            const payload = {
                payment_method_id: selectedPaymentMethod.id,
                payment_method: selectedPaymentMethod.type,
                store_id: currentStore.id,
                order_type: Number(getOrderTypeIdByName(orderType)),
                cart_id: isStoreCounter ? cartDisplay.id : cart.cart_id,
                observation: observation,
                ...(isStoreCounter && {cashier_id: cashier.id}),
                ...(isStoreCounter && {cashier_id: cashier.id}),
                ...(isStoreCounter && cartDisplay.order?.id ? { order_id: cartDisplay.order.id } : {}), //* utilizado após o cancelamento do pagamento, no segundo createOrder
                ...(selectedPaymentMethod.customer_card_id ? { customer_card_id: selectedPaymentMethod.customer_card_id } : {}) //* utilizado para pagamento com cartão salvo
            }

            if (selectedPaymentMethod.type === METHOD_PAYMENT_TYPE_PIX) {
                setMainLoadingTitle('Gerando código PIX');
                createOrder(payload);
            } else if (selectedPaymentMethod.type === METHOD_PAYMENT_TYPE_CARD_ONLINE) {
                setMainLoadingTitle('Efetuando pagamento');
                //* incluindo pagamento dados do cartão no payload (removendo payment_method_id)
                const { payment_method_id, ...restPayload } = payload;
                const payloadUpdated = ({
                    ...restPayload,
                    ...currentCard
                });
                createOrder(payloadUpdated);
            } else if (selectedPaymentMethod.type === METHOD_PAYMENT_TYPE_GOOGLE_PAY) {
                setMainLoadingTitle('Efetuando pagamento');
                if (googlePayToken) {
                    const payloadUpdated = ({
                        ...payload,
                        google_pay_token: googlePayToken,
                        billing_address: billingAddress
                    });
                    createOrder(payloadUpdated);
                }
            }
        }
    }

    const createOrder = async (payload: any) => {

        setMainLoading(true);
        setMainLoadingMessage('Aguarde...');

        try {
            const orderService = new OrderService(orderType, token);
            const response = await orderService.create(payload);
            const orderCreated = response.order

            if (orderCreated) {
                setOrder(orderCreated);
                setShowRegisterCard(false);
                handleChangeMethod(null);
                setMainLoading(false);

                if (!isStoreCounter) {
                    createGuestCart();
                }

                if (orderCreated.payment_method.type === METHOD_PAYMENT_TYPE_PIX && orderCreated.status === ORDER_STATUS_AWAITING_PAYMENT) {
                    setShowPixCode(true);
                    goToOrderPlace(orderCreated);
                } else {
                    handleOrderFinished(orderCreated);
                }
            } else {
                storeIsOpen(); //! VERIFICAR HORARIO PEDIDO / LOCALSTORAGE
            }
          } catch (error) {
            setMainLoadingIcon(false);
            setMainLoadingIconError(true);
            setMainLoadingTitle('Ops! Algo não deu certo.');
            setMainLoadingMessage(
                isStoreCounter
                    ?   'Tente novamente e, caso persista, chame o garçom.'
                    :   'Tente novamente em alguns instantes.'
            );
            setMainLoadingCloseButton(true);
          }
    }

    const getCustomerCards = async () => {
        const payload = {
            store_id: currentStore.id,
        }
        try {
            const customerService = new CustomerService(orderType, token);
            const getCards = isStoreCounter
                    ? await customerService.getCardsStoreCounter(payload)
                    : await customerService.getCards(user.id, payload)

            if (getCards) {
                const getCardsUpdated = getCards.cards.map((card: any) => ({
                    ...card,
                    type: METHOD_PAYMENT_TYPE_CARD_ONLINE,
                }));

                setCustomerCards(getCardsUpdated);
                const cardMain = getCardsUpdated.find((card: any) => card.main === true);
                if (cardMain) {
                    handleChangeMethod(cardMain);
                }
            }
            } catch (error) {
                setCustomerCards(null)
            } finally {
                setLoadingGetCards(false);
            }
    }

    useEffect(() => {
        if (paymentMethod) {
            setLabelBtnPay(paymentMethod && paymentMethod.type === METHOD_PAYMENT_TYPE_PIX ? 'Gerar código PIX' : 'Efetuar pagamento');
        } else {
            setLabelBtnPay('Escolha como pagar');
        }
    }, [paymentMethod])

    const handleCancelCpf = () => {
        setShowInputCpf(false)
        setCpf('')
    }

    const handleCancelObservation = () => {
        setShowInputObservation(false)
    }

    const handleChangeMethod = (method: any) => {
        setShowRegisterCard(false);
        if (method?.payment_method === METHOD_PAYMENT_TYPE_CARD_ONLINE) {
            const methodUpdated = {...method, customer_card_id: method.id }
            setPaymentMethod(methodUpdated);
        } else {
            setPaymentMethod(method);
        }
        setCurrentCard(null);
    }

    const handleChangeMethodCard = () => {
        setShowRegisterCard(true);
        goScrollTo();
        setPaymentMethod(methodCardOnline);
    }

    const handleOrderFinished = (order: any) => {
        setMainLoading(false);
        setShowPixCode(false);

        if (isStoreCounter) {
            cartFinished({id: cartDisplay.id, order: order});
            goToHome();
        } else {
            goToOrderPlace(order);
        }
    }

    const getImageBrandByBrand = (brand: string) => {
        const method = listAllPaymentMethods?.find((method: any) => method.slug === brand.toLowerCase());
        return method ? method.image_url : null;
    }

    if ((isStoreCounter && !cartDisplay) || (!isStoreCounter && !token)) return null;

    return (
        <>
            <section className='flex flex-col flex-grow w-full h-dvh'>
                {loading
                    ?
                        <>
                            <HeaderMinimal title="Pagamento" subtitle="Carregando..." />
                            <div className="flex items-center justify-center gap-1 h-full text-sm text-gray-500">
                                <ImSpinner8 className="animate-spin" />
                                <span>{isStoreCounter ? 'Carregando comanda' : 'Carregando pedido'}</span>
                            </div>
                        </>
                    :
                        (cart && cart.empty) || (cart.empty && !showPixCode)
                            ?   <CardEmpty onCloseCart={() => handleCancel()} />
                            :
                                <div className="relative flex flex-col md:flex-row justify-between h-full">
                                    <section className={`flex flex-col w-full md:overflow-y-auto ${loadingListPaymentMethods && !showPixCode ? 'h-full ' : ''}`}>
                                        <div className=" sticky top-[-1px] z-30">
                                            <HeaderMinimal title="Pagamento" subtitle={isStoreCounter ? 'Feche sua conta' : 'Finalize seu pedido'} />
                                        </div>

                                        {/* PAYMENT METHOD */}
                                        <div id='boxPaymentMethods' className={`sticky top-0 bg-white/95 z-30 p-4 pb-0 flex flex-col gap-4 w-full ${loadingListPaymentMethods && !showPixCode ? 'h-full' : ''}`}>

                                            {loadingListPaymentMethods &&
                                                <div className="flex items-center justify-center gap-1 h-full md:h-auto text-gray-500">
                                                    <ImSpinner8 className="animate-spin" />
                                                    <span>Carregando formas de pagamento...</span>
                                                </div>
                                            }

                                            <nav className={`grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 w-full mb-3 ${cart.empty || cart.total === 0 ? 'grayscale pointer-events-none' : ''}`}>

                                                {(hasPaymentGooglePay && !loadingListPaymentMethods) && (
                                                    <div className="mb-1 col-span-3 lg:col-span-3 xl:col-span-4">
                                                        <GooglePayButton
                                                            valueTotal={cart.total}
                                                            method={paymentMethodTypeGooglePay}
                                                            onCreateOrder={handleCreateOrderWithGooglePay}
                                                            onCancel={() => {}}
                                                        />
                                                    </div>
                                                )}

                                                {!loadingListPaymentMethods && listPaymentMethods?.map((method: any, index: number) => {
                                                    if (method.type !== METHOD_PAYMENT_TYPE_GOOGLE_PAY) {
                                                        return (
                                                            <ButtonMethodPayment
                                                                onClick={() => handleChangeMethod(method)}
                                                                label='Pagar com'
                                                                title={method.name}
                                                                image_url={method.image_url ?? ''}
                                                                active={paymentMethod?.type === method.type}
                                                                disabled={paymentMethod?.type === method.type}
                                                                key={index}
                                                            >
                                                                {paymentMethod?.type === method.type && <TbCircleCheckFilled size={20} className='absolute -right-1.5 -top-1.5 bg-white rounded-full text-custom-primary zoomInIconNoDelay' />}
                                                            </ButtonMethodPayment>
                                                        );
                                                    }
                                                    return null;
                                                })}

                                                {((isStoreCounter && showPrePayd) || !isStoreCounter) &&
                                                    <>
                                                    {(!loadingGetCards && customerCards) &&
                                                        customerCards.map((card: any, index: number) =>
                                                            <ButtonMethodPayment
                                                                label="Meu cartão"
                                                                title={card.brand}
                                                                image_url={getImageBrandByBrand(card.brand)}
                                                                active={paymentMethod?.id === card.id}
                                                                onClick={() => handleChangeMethod(card)}
                                                                className="relative"
                                                                loading={loadingListPaymentMethods}
                                                                number={card.masked_number.slice(-4)}
                                                                main={card.main}
                                                                key={index}
                                                            >
                                                                {paymentMethod?.id === card.id && <TbCircleCheckFilled size={20} className='absolute -right-1.5 -top-1.5 bg-white rounded-full text-custom-primary zoomInIconNoDelay' />}
                                                            </ButtonMethodPayment>
                                                        )}

                                                        {!loadingListPaymentMethods &&
                                                            <ButtonMethodPayment
                                                                payCard
                                                                label={customerCards?.length > 0 ? 'Pagar com outro' : 'Pagar com'}
                                                                title="Cartão"
                                                                active={paymentMethod?.type === methodCardOnline?.type && paymentMethod?.register}
                                                                disabled={showRegisterCard}
                                                                onClick={handleChangeMethodCard}
                                                                className="relative"
                                                                loading={loadingListPaymentMethods}
                                                            >
                                                                {showRegisterCard && <TbCircleCheckFilled size={20} className='absolute -right-1.5 -top-1.5 bg-white rounded-full text-custom-primary zoomInIconNoDelay' />}
                                                            </ButtonMethodPayment>
                                                        }
                                                    </>
                                                }
                                            </nav>

                                        </div>


                                        <div className="flex flex-col justify-between h-full gap-4 p-4 text-sm">

                                            <section className="flex flex-col gap-2 w-full h-full md:h-max md:pb-20">

                                                {showRegisterCard &&
                                                    <FormRegisterCustomerCard
                                                        onCancel={() => { setShowConfirmCancel(true) }}
                                                        onSetCard={handleSetCard}
                                                    />
                                                }

                                                {/* COUPON */}
                                                {!isStoreCounter &&
                                                    <CardBoxCheckout iconTop={false} icon={<TbTicket className="-rotate-45" />}>
                                                        <div className="flex gap-2 items-center w-full">

                                                            <div className="flex gap-2 flex-col w-full items-center">
                                                                <div className="relative flex items-center justify-center w-full">
                                                                    <IMaskInput
                                                                        mask="#******************************"
                                                                        definitions={{
                                                                        '*': /[A-Za-z0-9-]/,
                                                                        }}
                                                                        radix=""
                                                                        onAccept={(value) => setCouponCode(value)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handleCoupon();
                                                                            }
                                                                          }}
                                                                        unmask={false}
                                                                        name="coupon_code"
                                                                        value={couponCode}
                                                                        placeholder="Digite o código do cupom"
                                                                        disabled={loadingCoupon || couponCodeApplied}
                                                                        className={`
                                                                            flex w-full rounded-lg
                                                                            border-0
                                                                            pr-28
                                                                            text-custom-primary
                                                                            placeholder:text-gray-600
                                                                            placeholder:font-semibold
                                                                            focus:text-base
                                                                            outline-none
                                                                            transition-all ease-in-out duration-200
                                                                            ${(couponCodeApplied || loadingCoupon) ? 'bg-transparent p-1 font-extrabold text-base' : 'font-bold p-2.5 ring-1 ring-gray-200 focus:ring-custom-primary focus:ring-2 focus:outline-none'}
                                                                            `}
                                                                        />
                                                                    <button
                                                                        type="button"
                                                                        disabled={loadingCoupon}
                                                                        onClick={handleCoupon}
                                                                        className={`
                                                                            absolute text-custom-primary rounded-full p-1 pr-0 focus-visible:outline transition-width ease-in-out duration-200
                                                                            ${couponCodeApplied ? '-right-1' : 'right-2 hover:bg-gray-100'}
                                                                        `}
                                                                        >
                                                                        {couponCodeApplied && loadingCoupon
                                                                            ?   <div className="flex items-center gap-1 text-gray-400 text-xs font-medium mr-1"><ImSpinner8 className="animate-spin" />Removendo</div>
                                                                            :   loadingCoupon
                                                                                    ?   <div className="flex justify-center gap-1 items-center w-20 text-gray-400 text-xs font-medium mr-1"><ImSpinner8 className="animate-spin" />Aplicando</div>
                                                                                    :   couponCodeApplied
                                                                                            ?  <ButtonPrimary outline onClick={() => {}} className="h-6 w-20 zoomInIconNoDelay text-xs text-shopfood-error hover:text-shopfood-error ring-shopfood-error hover:ring-shopfood-error">Remover</ButtonPrimary>
                                                                                            :   isValidCouponCode && <ButtonPrimary onClick={() => {}} className="h-6 w-20 fadeInIcon text-xs">Aplicar</ButtonPrimary>
                                                                        }
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </CardBoxCheckout>
                                                }

                                                {/* STORE */}
                                                {(currentStore && !isStoreCounter) &&
                                                    <CardBoxCheckout icon={<TbBuildingSkyscraper />}>
                                                        <div className="flex gap-2 items-center w-full">
                                                            <div className="flex flex-col w-full">
                                                                <span className="flex items-center justify-between text-gray-400">
                                                                    <span>Loja</span>
                                                                    <button onClick={() => setShowStoreAddress(!showStoreAddress)} className="inline-flex items-center gap-0.5 text-xs font-medium">
                                                                        {showStoreAddress ? <>Ocultar endereço</> : <>Exibir endereço</> }
                                                                    </button>
                                                                </span>
                                                                <span className="font-semibold flex justify-between gap-2">
                                                                    {currentStore.name}
                                                                </span>
                                                                <div className={`transition-all ease-in-out duration-200 text-gray-500 leading-4 mt-0.5 ${showStoreAddress ? 'opacity-100 h-auto' : 'opacity-0 h-0'}`}>{ formatAddressStore(currentStore) }</div>
                                                            </div>
                                                        </div>
                                                    </CardBoxCheckout>
                                                }

                                                {/* DELIVERY ADDRESS */}
                                                {isDelivery &&
                                                    <CardBoxCheckout icon={<TbMapPin />}>
                                                        <div className="flex gap-2 items-center w-full">
                                                            <div className="flex flex-col w-full">
                                                                <span className="text-gray-400">Endereço de entrega</span>
                                                                <span className="font-semibold">Praia de Botafogo, 300, Rio de Janeiro - RJ - CEP 22250-040</span>
                                                            </div>
                                                        </div>
                                                        <section className="text-gray-400">
                                                            Estimativa de entrega: <span className="font-semibold">{ currentStore.shipping_time } minutos</span>
                                                        </section>
                                                    </CardBoxCheckout>
                                                }

                                                {/* CPF */}
                                                {(!loadingListPaymentMethods) &&
                                                    <CardBoxCheckout icon={<TbId />}>
                                                        <div className="flex gap-2 items-center w-full">
                                                            <div className="flex flex-col w-full">
                                                                <span className="text-gray-400">CPF na nota</span>
                                                                {!showInputCpf && <span className="font-semibold">{cpf ? formatCpf(cpf) : 'Não informado'}</span> }

                                                                {(showInputCpf) &&
                                                                    <div className="flex gap-2 flex-col w-full">
                                                                        <div className="relative flex items-center justify-center w-full">
                                                                            <IMaskInput
                                                                                mask="000.000.000-00"
                                                                                radix=""
                                                                                inputMode="numeric"
                                                                                onAccept={(value) => setCpf(value)}
                                                                                unmask={true} // true|false|'typed'
                                                                                name="cpf"
                                                                                value={cpf}
                                                                                placeholder="Opcional"
                                                                                className="
                                                                                    flex w-full rounded-lg
                                                                                    border-0
                                                                                    mt-0.5
                                                                                    p-2.5 pr-28
                                                                                    font-extrabold
                                                                                    placeholder:text-gray-300
                                                                                    placeholder:font-normal
                                                                                    ring-1
                                                                                    ring-gray-200
                                                                                    outline-none
                                                                                    focus:ring-custom-primary
                                                                                    focus:ring-2
                                                                                    focus:outline-none
                                                                                    transition-all ease-in-out duration-200"
                                                                            />
                                                                            {cpf && !isCpfValid(cpf) && <span className="absolute right-2 text-xs font-medium text-shopfood-error">Inválido</span>}
                                                                        </div>
                                                                        <div className="flex gap-1.5 text-xs">
                                                                            <ButtonLink outline onClick={handleCpf} disabled={!isCpfValid(cpf)} className="h-8">Adicionar</ButtonLink>
                                                                            <Button onClick={handleCancelCpf} className='h-8'>Cancelar</Button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>

                                                            {!showInputCpf &&
                                                                <ButtonLink onClick={() => setShowInputCpf(true)} className="text-xs gap-0.5 text-xs h-8">
                                                                    {!cpf ? 'Adicionar' : 'Alterar' }
                                                                </ButtonLink>
                                                            }
                                                        </div>
                                                    </CardBoxCheckout>
                                                }

                                                {/* OBSERVACAO */}
                                                {(!isStoreCounter) &&
                                                    <CardBoxCheckout icon={<TbMessage />}>
                                                        <div className="flex gap-2 items-center w-full">

                                                            <div className="flex flex-col w-full">
                                                                <span className="text-gray-400">Observação</span>
                                                                {!showInputObservation && <span className="font-semibold">{observation ? observation : 'Nenhuma'}</span> }

                                                                {(showInputObservation) &&
                                                                    <div className="flex gap-2 flex-col w-full">
                                                                        <textarea
                                                                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setObservation(e.target.value)}
                                                                            name="observation"
                                                                            value={observation}
                                                                            placeholder="Preencha só o que for do pedido. Obrigado!"
                                                                            className={`
                                                                                block w-full rounded-md border-0 p-2.5 shadow ring-1 ring-gray-300
                                                                                placeholder:text-gray-300
                                                                                focus:ring-2 focus:ring-custom-primary
                                                                                transition-all ease-in-out duration-500
                                                                                ${observation ? 'h-24' : 'h-14'}
                                                                                focus:h-24
                                                                            `}
                                                                        />
                                                                        <div className="flex gap-1.5 text-xs">
                                                                            <ButtonLink outline onClick={handleObservation} disabled={!observation} className="h-8">Adicionar</ButtonLink>
                                                                            <Button onClick={handleCancelObservation} className='self-start h-8'>Cancelar</Button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>

                                                            {!showInputObservation &&
                                                                <ButtonLink onClick={() => setShowInputObservation(true)} className="text-xs gap-0.5 text-xs h-8">
                                                                    {!observation ? 'Adicionar' : 'Alterar' }
                                                                </ButtonLink>
                                                            }
                                                        </div>
                                                    </CardBoxCheckout>
                                                }

                                            </section>
                                        </div>

                                        {(!showRegisterCard) &&
                                            <div className="hidden md:flex sticky bottom-0 bg-white gap-2 p-4 w-full justify-end">
                                                <ButtonsCheckout
                                                    label={labelBtnPay}
                                                    disabledFinish={cart.total === 0 || cart.empty}
                                                    onFinishOrder={handleCheckOrdersOpen}
                                                    onCancel={() => setShowConfirmCancel(true)}
                                                    method={paymentMethod}
                                                />
                                            </div>
                                        }
                                    </section>

                                    <section className={`h-full w-full md:max-w-md md:shadow-xl md:shadow-gray-100 p-2 md:px-0 md:py-4 ${showRegisterCard ? 'pb-20' : ''}`}>
                                        <Cart onCloseCart={() => handleCancel()} onCartInfo={(e: any) => setCart(e)} />
                                    </section>

                                    {/* OCULTANDO BOTAO PARA PAGAMENTO VIA CARTAO ONLINE */}
                                    {(!showRegisterCard) &&
                                        <div className="absolute w-full flex md:hidden sticky bottom-0 right-0 p-4 gap-2 w-full bg-white">
                                            <ButtonsCheckout
                                                label={labelBtnPay}
                                                disabledFinish={cart.total === 0 || cart.empty}
                                                onFinishOrder={handleCheckOrdersOpen}
                                                onCancel={() => setShowConfirmCancel(true)}
                                                method={paymentMethod}
                                            />
                                        </div>
                                    }
                                </div>
                }
            </section>

            <Modal open={showConfirmCancel} className="max-w-sm m-4" onClose={() => setShowConfirmCancel(false)}>
                <Confirm
                    title="Tem certeza?"
                    message="Deseja realmente sair da tela de pagamento?"
                    labelConfirm="Sim, quero sair"
                    onConfirm={() => handleCancel()}
                    onCancel={() => setShowConfirmCancel(false)}
                />
            </Modal>

            <Modal open={showConfirmOrdersOpen} className="max-w-sm m-4" onClose={() => setShowConfirmOrdersOpen(false)}>
                <Confirm
                    icon={CONFIRM_ICON_INVOICE}
                    title="Vimos que você já tem um pedido em aberto."
                    message="Quer continuar mesmo assim?"
                    labelConfirm="Sim, quero continuar"
                    onConfirm={handleCreateOrder}
                    onCancel={() => setShowConfirmOrdersOpen(false)}
                />
            </Modal>

        </>
    )
}

export default Checkout;